import { AuthContext } from "oidc-react";
import { useContext } from "react";

export function useBearerToken(): string | undefined {
  const authContext = useContext(AuthContext);
  return authContext?.userData?.access_token;
}
